// extracted by mini-css-extract-plugin
module.exports = {"item":"detail_item__2I1J7","text":"detail_text__2gvX_","action":"detail_action__2ysP9"};